import React from 'react';

/**
 * Default expanded row renderer that shows all columns
 */
export function defaultExpandedRowRenderer(columns: any[], row: any): React.ReactElement {
    return (
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4 text-sm">
            {columns.map((col) => {
                let content: React.ReactNode;

                if (col.render) {
                    content = col.render(row);
                } else if (col.format) {
                    const value = row[col.key] as any;
                    content = col.format(value);
                } else {
                    const value = row[col.key];
                    content = value?.toString() || '-';
                }

                return (
                    <div key={col.key} className="flex flex-col">
                        <span className="font-semibold text-gray-700 dark:text-gray-300 mb-1">
                            {col.label}:
                        </span>
                        <div className="text-gray-600 dark:text-gray-400">
                            {content}
                        </div>
                    </div>
                );
            })}
        </div>
    );
}
